import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface DetailsTabsProps {
  defaultValue?: number;
  disabled?: boolean;
  labels?: React.ReactNode[];
  onChange?: (event: { target: { value: number } }) => void;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({
  defaultValue = 0,
  disabled,
  labels = [],
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (onChange) {
      onChange({ target: { value: newValue } });
    }
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      centered
      variant="fullWidth"
    >
      {labels.map((label, index) => (
        <Tab
          key={`detail-tab-${index}`}
          label={label}
          disabled={disabled}
          style={{ fontWeight: 800 }}
        />
      ))}
    </Tabs>
  );
};

export default DetailsTabs;
